import { useMutation } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { InventoryBoxQrsListItem } from "../../inventory.types";
import { requestCreateInventoryBoxQr } from "./createInventoryBoxQr.request";

const useCreateInventoryBoxQr = (
  options?: MutationOptions<InventoryBoxQrsListItem, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestCreateInventoryBoxQr,
    onError: toastServerError,
    ...options
  });
};

export default useCreateInventoryBoxQr;
